package io.eqoty.shared.datalayer.objects


data class StreamingFormatPreference(val container: AudioContainer, val quality: Quality) {
    enum class Quality {
        Low,
        Medium,
        High
    }
}